import { Modal } from 'react-bootstrap';
import { IoChatbubblesOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';

export function WaitingAttendanceModal({ show, onHide }: { show: boolean; onHide: () => void }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="border-0 pb-0" closeButton />
      <Modal.Body>
        <>
          <span className="d-flex justify-content-center">
            <IoChatbubblesOutline size="150" color="#800000" />
          </span>
          <h5 className="text-center">
            <strong>Aguardando atendimento</strong>
          </h5>
          <p className="text-center text-muted">
            Seu pedido já foi encaminhado para a <strong>equipe de vendas</strong>, por favor,{' '}
            <strong>aguarde</strong>
          </p>
        </>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Link to="/" className="btn w-100" style={{ backgroundColor: '#800000', color: '#fff' }}>
          Continuar comprando
        </Link>
        <button className="btn btn-outline-info w-100" onClick={onHide}>
          Voltar
        </button>
      </Modal.Footer>
    </Modal>
  );
}
